import { render } from "./Pager.vue?vue&type=template&id=36e14534&scoped=true&bindings={\"totalCount\":\"props\",\"pageNum\":\"props\",\"rowCnt\":\"props\",\"hasPrevPage\":\"setup\",\"hasNextPage\":\"setup\",\"pagerArr\":\"setup\",\"totalPageLength\":\"setup\",\"clickPagerBtn\":\"setup\"}"
import script from "./Pager.vue?vue&type=script&lang=ts"
export * from "./Pager.vue?vue&type=script&lang=ts"

import "./Pager.vue?vue&type=style&index=0&id=36e14534&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36e14534"

export default script